import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Pic } from "@/components/Pic";
import { thumbUrl } from "@/lib/images";
import { imageAlt } from "@/lib/imageAlt";

const MAX = 10;
const navBtn = "absolute top-1/2 -translate-y-1/2 z-10 w-8 h-8 rounded-full bg-white/90 text-stone-700 shadow flex items-center justify-center hover:bg-white transition-opacity opacity-0 group-hover:opacity-100 focus-visible:opacity-100 [@media(hover:none)]:opacity-100";

/** Kartenbild zum Blättern (Pfeile links/rechts + Zähler, am Handy auch per Wischen); Klicks auf die Pfeile öffnen nicht das Objekt. */
export const CardGallery = ({ property, title, lang }) => {
  const imgs = [property.hero_image, ...(property.images || []).filter((u) => u && u !== property.hero_image)].filter(Boolean).slice(0, MAX);
  const [i, setI] = useState(0);
  useEffect(() => setI(0), [property.id]);
  const n = imgs.length;
  const idx = Math.min(i, Math.max(n - 1, 0));
  const step = (d) => setI((idx + d + n) % n);
  const go = (e, d) => { e.preventDefault(); e.stopPropagation(); step(d); };
  const touch = useRef(null);
  const onTouchStart = (e) => { const t = e.touches[0]; touch.current = { x: t.clientX, y: t.clientY }; };
  const onTouchEnd = (e) => {
    const s = touch.current; touch.current = null;
    if (!s || n < 2) return;
    const t = e.changedTouches[0]; const dx = t.clientX - s.x; const dy = t.clientY - s.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
  };
  const src = imgs[idx] || property.hero_image;
  return (
    <div className="absolute inset-0 [touch-action:pan-y]" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} data-testid="card-gallery">
      <Pic key={src} src={thumbUrl(src)} webp={property.webp_ready} alt={imageAlt(property, title, lang, n > 1 ? idx : null, n > 1 ? n : null, src)} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      {n > 1 && (<>
        <button type="button" onClick={(e) => go(e, -1)} aria-label="Vorheriges Bild" className={`${navBtn} left-2`} data-testid="card-img-prev"><ChevronLeft className="w-4 h-4" /></button>
        <button type="button" onClick={(e) => go(e, 1)} aria-label="Nächstes Bild" className={`${navBtn} right-2`} data-testid="card-img-next"><ChevronRight className="w-4 h-4" /></button>
        <span className="absolute bottom-3 left-3 z-10 rounded-full bg-black/45 text-white text-[11px] px-2 py-0.5 tabular-nums" data-testid="card-img-counter">{idx + 1} / {n}</span>
      </>)}
    </div>
  );
};
